import { AxiosInstance, AxiosResponse } from 'axios'

export interface ConferenceParticipant {
  id: string
  number: string
  user: {
    id: number
    username: string
    additionalInfo: any
  }
}

export default class ConferenceAPI {
  public _client: AxiosInstance

  constructor(axios: AxiosInstance) {
    this._client = axios
  }

  public async get(
    roomId: number | string,
  ): Promise<Array<ConferenceParticipant>> {
    const response: AxiosResponse = await this._client.get(
      `conferences/1/${roomId}`,
    )
    if (response.data.data) {
      return response.data.data.attributes.participants.map(
        (participant: any) => {
          if (participant.user) {
            participant.user = {
              id: participant.user.id,
              username: participant.user.username,
              additionalInfo: participant.user.additionalInfo,
            }
          }
          return participant
        },
      )
    }
    return []
  }

  public async delete(roomId: number | string): Promise<void> {
    await this._client.delete(`conferences/1/${roomId}`)
  }

  public async kick(roomId: number | string, participantId: string) {
    await this._client.delete(
      `conferences/1/${roomId}/participants/${participantId}`,
    )
  }
  public async hold(roomId: number | string, participantId: string) {
    await this._client.patch(
      `conferences/1/${roomId}/participants/${participantId}/hold`,
    )
  }
  public async unHold(roomId: number | string, participantId: string) {
    await this._client.patch(
      `conferences/1/${roomId}/participants/${participantId}/unHold`,
    )
  }
}
